import React from 'react';
import { TagIcon, PercentIcon } from 'lucide-react';
interface MerchantCardProps {
  name: string;
  category: string;
  discount: string;
  logo?: string;
  description?: string;
}
export function MerchantCard({
  name,
  category,
  discount,
  logo,
  description
}: MerchantCardProps) {
  return <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-600/20 rounded-xl p-6 hover:border-yellow-600/40 transition-all group" data-id="element-116">
      {/* Logo/Icon */}
      <div className="w-16 h-16 bg-yellow-600/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-yellow-600/20 transition-colors" data-id="element-117">
        {logo ? <img src={logo} alt={name} className="w-12 h-12 object-contain" data-id="element-118" /> : <span className="text-2xl font-bold text-yellow-400" data-id="element-119">
            {name.charAt(0)}
          </span>}
      </div>

      {/* Merchant Info */}
      <h3 className="text-xl font-bold text-white mb-2" data-id="element-120">{name}</h3>

      <div className="flex items-center gap-2 mb-3" data-id="element-121">
        <TagIcon className="w-4 h-4 text-yellow-400" data-id="element-122" />
        <span className="text-sm text-gray-400" data-id="element-123">{category}</span>
      </div>

      {description && <p className="text-gray-400 text-sm mb-4 line-clamp-2" data-id="element-124">{description}</p>}

      {/* Discount Badge */}
      <div className="flex items-center gap-2 px-4 py-2 bg-yellow-600/20 border border-yellow-600/30 rounded-lg" data-id="element-125">
        <PercentIcon className="w-4 h-4 text-yellow-400" data-id="element-126" />
        <span className="text-yellow-400 font-semibold text-sm" data-id="element-127">
          {discount}
        </span>
      </div>
    </div>;
}